import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(fmtError(err));
    }
  };

  return (
    <div className="min-h-screen bg-teca-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-card rounded-2xl p-6 shadow-2xl" data-testid="forgot-form">
        <h1 className="font-display text-2xl font-bold uppercase mb-4">Mot de passe oublié</h1>
        {done ? (
          <p data-testid="forgot-confirmation" className="text-sm">Si cet e-mail est enregistré, un lien de réinitialisation a été envoyé.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@teca.fr" className="py-3.5" />
            {error && <div className="text-sm text-red-600">{error}</div>}
            <Button data-testid="forgot-submit" type="submit" className="w-full h-13 bg-amber-500 text-slate-900 font-bold hover:bg-amber-400">ENVOYER LE LIEN</Button>
          </form>
        )}
        <Link to="/login" data-testid="back-to-login" className="block text-center text-sm text-amber-600 font-semibold mt-4 hover:underline">
          Retour à la connexion
        </Link>
      </div>
    </div>
  );
}
